import { CutType } from '@api/cut';
import { UserType } from './permissions';

export enum CutStatus {
    Pending = 'Pending',
    Approved = 'Approved',
    Denied = 'Denied',
    NotYetInvoiced = 'Not Yet Invoiced',
    Invoiced = 'Invoiced',
    Credit = 'Credit',
    Credited = 'Credited',
    Void = 'Void',
}

/**
 * A map where the top-level keys pertain to previous cut statuses which can
 * be transitioned from, and the child keys pertain to users that can perform
 * the status transition. The child keys' values are arrays of statuses those
 * user types are allowed to transition to for the specific top-level status.
 */
type CutStatusMap = {
    [PreviousStateKey in CutStatus]?: {
        [User in UserType]?: CutStatus[];
    };
};

const successfulCutStatusOptions: CutStatusMap = {
    [CutStatus.NotYetInvoiced]: {
        [UserType.Finance]: [CutStatus.Void],
        [UserType.Support]: [CutStatus.Void],
    },
    [CutStatus.Invoiced]: {
        [UserType.Finance]: [CutStatus.Credit],
    },
    [CutStatus.Credit]: {
        [UserType.Finance]: [CutStatus.Invoiced],
    },
};

const warrantyClaimStatusOptions: CutStatusMap = {
    [CutStatus.Pending]: {
        [UserType.Finance]: [CutStatus.Denied, CutStatus.Void, CutStatus.Approved],
        [UserType.Support]: [CutStatus.Void],
    },
    [CutStatus.Denied]: {
        [UserType.Finance]: [CutStatus.Approved, CutStatus.Void],
    },
    [CutStatus.Approved]: {
        [UserType.Finance]: [CutStatus.Denied],
    },
    [CutStatus.Invoiced]: {
        [UserType.Finance]: [CutStatus.Credit],
    },
};

export const cutStatusChangeMap: Record<CutType, CutStatusMap> = {
    [CutType.Successful]: successfulCutStatusOptions,
    [CutType.Warranty]: warrantyClaimStatusOptions,
    [CutType.FailedCut]: {},
};
